import React from 'react';
import classNames from 'classnames';

import Category from 'components/Listing/Categories/Category/Category';
import Slide from 'components/Common/Slide/Slide';
import { getUri } from 'services/generic';
import { env } from 'settings/env';
import {
  CategoriesType,
  CategoryType,
} from 'types/ProductListing/ProductListing';

import styles from './Categories.module.scss';

type PropsType = {
  categories: CategoriesType;
  className?: string;
};

export default function Categories({
  categories: { displayThumbnail, list },
  className,
}: PropsType): JSX.Element {
  return (
    <Slide
      items={list}
      renderItem={category => renderCategory(category, displayThumbnail)}
      loopKey={item => item.label}
      options={{
        autoWidth: true,
        omitEnd: true,
      }}
      className={classNames(styles.slide, className)}
      classes={{
        arrow: styles.arrow,
        slide: styles.category,
        track: styles.track,
      }}
    />
  );
}

function renderCategory(
  category: CategoryType,
  displayThumbnail: boolean
): JSX.Element {
  const { label, url, thumbnail } = category;
  return (
    <Category
      label={label}
      url={getUri(url)}
      {...(thumbnail && {
        thumbnail: `${env.ENV_TWICPICS_WYSIWYG_OCTIPAS_URL}/listing-thumbnail-category/${thumbnail}`,
      })}
      displayThumbnail={displayThumbnail}
    />
  );
}
